

const optionsData = [
  { name: "Groupements d'achat", id: "markets" },
  { name: "MBM", id: "mbm" },
  { name: "Import de données", id: "import" },
  { name: "Campagnes CEE", id: "cee" },
  { name: "Maps", id: "maps" },
  { name: "Alertes", id: "alertes" },
  { name: "Evènements", id: "events" },
  { name: "Compteurs", id: "meters" },
  { name: "Factures", id: "bills" },
  { name: "Budgets", id: "budget" },
  { name: "Plan d'actions", id: "actionplans" },
  { name: "Exports", id: "exports" },
  { name: "Véhicules", id: "vehicles" },
  { name: "GEB", id: "geb" },
];

const logtypeData = [
  { name: "Visite de page", id: "page visit" },
  { name: "Connexion", id: "connection" },
  { name: "Modification d'un groupe", id: "group update" },
];

const logeventData = [
  { name: "Connexion réussie", id: "connection success" },
];

const usertypeData = [
  { name: "Utilisateur", id: 0 },
  { name: "Administrateur", id: 1 },
  { name: "Administrateur local", id: 2 },
  { name: "Administrateur MEM", id: 3 },
];

const usertypechangeadminData = [
  { name: "Utilisateur", id: 0 },
  { name: "Administrateur", id: 1 },
  { name: "Administrateur MEM", id: 3 },
];

const usertypechangeadminmemData = [
  { name: "Utilisateur", id: 0 },
  { name: "Administrateur MEM", id: 3 },
];

const memv2versionData = [
  { name: "Silver", id: 0 },
  { name: "Gold", id: 1 },
  { name: "Platinum", id: 2 },
]

export { optionsData,logtypeData,logeventData,usertypeData, memv2versionData, usertypechangeadminData, usertypechangeadminmemData };
